import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaStar, FaCheckCircle, FaUsers } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import { MdRocket } from 'react-icons/md';
import { RiShieldCheckFill } from 'react-icons/ri';
import { BsCurrencyDollar } from 'react-icons/bs';

const Home = () => {
  const platforms = [
    {
      name: 'Facebook',
      icon: <FaFacebook className="text-3xl" />,
      color: 'bg-blue-600',
      description: 'Boost your Facebook page followers'
    },
    {
      name: 'Instagram',
      icon: <FaInstagram className="text-3xl" />,
      color: 'bg-pink-600',
      description: 'Increase your Instagram followers'
    },
    {
      name: 'YouTube',
      icon: <FaYoutube className="text-3xl" />,
      color: 'bg-red-600',
      description: 'Grow your YouTube subscriber base'
    },
    {
  name: 'TikTok',
  icon: <SiTiktok className="text-3xl" />,
  color: 'bg-black',
  description: 'Expand your TikTok followers'
},
    {
      name: 'Twitter',
      icon: <FaTwitter className="text-3xl" />,
      color: 'bg-sky-500',
      description: 'Enhance your Twitter followers'
    }
  ];

  const packages = [
    {
      name: 'Standard',
      followers: 500,
      price: 9.99,
      features: ['Real Followers', '24/7 Support', '30-Day Guarantee'],
      popular: false
    },
    {
      name: 'Medium',
      followers: 1000,
      price: 19.99,
      features: ['Real Followers', 'Fast Delivery', '24/7 Support', '30-Day Guarantee'],
      popular: true
    },
    {
      name: 'Pro',
      followers: 2000,
      price: 39.99,
      features: ['Real Followers', 'Instant Delivery', '24/7 Support', '30-Day Guarantee', 'Priority Support'],
      popular: false
    }
  ];

  const features = [
  {
    name: 'Real Followers',
    description: '100% real and active followers, no bots or fake accounts',
    icon: <FaUsers className="text-2xl" />
  },
  {
    name: 'Fast Delivery',
    description: 'Quick delivery within 24-48 hours for most packages',
    icon: <MdRocket className="text-2xl" />
  },
  {
    name: 'Money Back Guarantee',
    description: '30-day money-back guarantee if not satisfied',
    icon: <RiShieldCheckFill className="text-2xl" />
  },
  {
    name: 'Best Prices',
    description: 'Competitive pricing with no hidden fees',
    icon: <BsCurrencyDollar className="text-2xl" />
  }
];

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="hero-gradient text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-float">
              Grow Your Social Media
              <span className="block text-yellow-300">Presence Instantly</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-purple-100">
              Get real followers, likes, and engagement for all major social platforms
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
               <Link to="/packages" className="btn-primary">
                            View Packages
                          </Link>
                          <Link to="/contact" className="btn-secondary">
                            Our Services
                          </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Platforms Section */}
      <section className="py-16 bg-premium-white-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-purple mb-4">
              All Platforms Supported
            </h2>
            <p className="text-black text-lg">
              Choose from our wide range of social media platforms
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {platforms.map((platform) => (
              <Link
                key={platform.name}
                to={`/packages/${platform.name.toLowerCase()}`}
                className="card p-6  text-center hover:scale-105 transition-transform duration-300"
              >
                <div className={`${platform.color} w-16 h-16 rounded-full flex items-center justify-center text-white mx-auto mb-4`}>
                  {platform.icon}
                </div>
                <h3 className="font-semibold text-white">{platform.name}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-16 bg-gradient-to-br from-premium-white-200 to-premium-purple-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-premium-purple-200 mb-4">
              Choose Your Package
            </h2>
            <p className="text-lg text-purple-600">
              Flexible packages to suit your needs and budget
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {packages.map((pkg) => (
              <div key={pkg.name} className={`package-card ${pkg.popular ? 'featured' : ''}`}>
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
                    <span className="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-4 py-1 rounded-full text-xs font-bold">
                      POPULAR
                    </span>
                  </div>
                )}
                <div className="p-8 text-center">
                  <h3 className="text-2xl font-bold text-white mb-4">{pkg.name}</h3>
                  <div className="text-5xl font-bold text-white mb-2">
                    {pkg.followers.toLocaleString()}
                  </div>
                  <div className="text-lg text-white mb-6">Followers</div>
                  <div className="text-3xl font-bold text-white mb-8">
                    ${pkg.price}
                  </div>
                  <ul className="space-y-4 mb-8 text-left">
                    {pkg.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-white">
                        <FaCheckCircle className="text-purple-400 mr-3 flex-shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link to="/packages" className="btn-primary w-full">
                    Get Started
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gradient-to-br from-premium-purple-200 to-premium-purple-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Why Choose Followers Hub?
            </h2>
            <p className="text-white text-lg">
              We provide best social media growth services
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-purple-900 bg-opacity-50 rounded-full flex items-center justify-center text-purple-400 mx-auto mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">{feature.name}</h3>
                <p className="text-white">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-r from-brinjal-600 to-dark-purple-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">50K+</div>
              <div className="text-brinjal-100">Happy Customers</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">10M+</div>
              <div className="text-brinjal-100">Followers Delivered</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">99.9%</div>
              <div className="text-brinjal-100">Success Rate</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-2">24/7</div>
              <div className="text-brinjal-100">Support Available</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 bg-premium-purple-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              What Our Customers Say
            </h2>
            <p className="text-white text-lg">
              Join thousands of satisfied customers
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Sarah Johnson',
                platform: 'Instagram Influencer',
                text: 'Followers Hub helped me grow my Instagram account from 1K to 10K followers in just 2 weeks!',
                rating: 5
              },
              {
                name: 'Mike Chen',
                platform: 'Content Creator',
                text: 'The best service I\'ve used. Fast delivery and real followers. Highly recommend!',
                rating: 5
              },
              {
                name: 'Emma Davis',
                platform: 'Business Owner',
                text: 'Great for business growth. Our social media presence has improved significantly.',
                rating: 5
              }
            ].map((testimonial, index) => (
              <div key={index} className="card p-6">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400" />
                  ))}
                </div>
                <p className="text-white mb-4 italic">"{testimonial.text}"</p>
                <div>
                  <div className="font-semibold text-white">{testimonial.name}</div>
                  <div className="text-sm text-purple-300">{testimonial.platform}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 hero-gradient text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Grow Your Social Media?
          </h2>
          <p className="text-xl mb-8 text-purple-100">
            Join thousands of influencers and businesses who trust Followers Hub
          </p>
           <Link to="/packages" className="btn-primary">
                        Get Started Now
                      </Link>
                     
        </div>
      </section>
    </div>
  );
};

export default Home;
